import logo from '@/assets/logo.svg';

const NoContent = () => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} width="35px" />
        <div style={{ marginLeft: '8px' }}>ESG LENS</div>
      </div>
      <div style={{ marginLeft: '4px' }}>
        <div className="text-text-200">AI-Powered ESG Insights</div>
      </div>
    </div>
  );
};

export default NoContent;
